export default {
  apply: function (fn, delay, context, immediate = false) {
    let timer = null
    return function (...args) {
      clearTimeout(timer)
      if (immediate) {
        fn.apply(context, args)
      } else {
        timer = setTimeout(function () {
          fn.apply(context, args)
        }, delay)
      }
    }
  }
}
